import { nanoid } from 'nanoid';
import React from 'react';
import create from 'zustand';

export type Notification = {
  id?: string;
  type: 'info' | 'success' | 'warning' | 'error' | 'cardReminder';
  title?: string | React.ReactNode;
  message?: string | React.ReactNode;
  customIcon?: React.ReactNode;
  closeable?: boolean;
  hideOnDeclare?: boolean;
  autoClose?: number;
  progressBarPlacement?: 'top' | 'bottom';
  accent?: 'top' | 'right' | 'bottom' | 'left';
  URLRedirectOnClose?: string;
};

type NotificationsStore = {
  notifications: Notification[];
  addNotification: (notification: Notification) => void;
  dismissNotification: (id: string) => void;
  changeNotificationVisibility: (id: string) => void;
};

export const useNotificationStore = create<NotificationsStore>((set, get) => ({
  notifications: [],

  addNotification: (notification) => {
    const alreadyNotification = get().notifications.find(({ id }) => id === notification.id);

    if (!alreadyNotification) {
      set((state) => ({
        notifications: [
          ...state.notifications.filter(
            (notification) =>
              notification.id !== notification.id && notification.message !== notification.message
          ),
          { id: nanoid(), ...notification },
        ],
      }));
    }
  },

  dismissNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((notification) => notification.id !== id),
    })),

  changeNotificationVisibility: (id) => {
    const hideNotification = get().notifications.find(
      ({ id: _id, hideOnDeclare }) => _id === id && hideOnDeclare
    );

    if (hideNotification) {
      set((state) => ({
        notifications: state.notifications.map((notification) => {
          if (notification.id === id && notification.hideOnDeclare === true) {
            notification.hideOnDeclare = false;
          }
          return notification;
        }),
      }));
    }

    return '';
  },
}));
